module.exports = __webpack_public_path__ + "img/7.5a6ea9f3.png";